import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreator from '../../store/actions/index';
import { withRouter } from "react-router-dom";
import {
    withStyles, Dialog, DialogContent, DialogTitle, DialogActions,
    Table, TableContainer, TableBody, TableRow, TableCell
} from "@material-ui/core";
import t from "../../languages/pl";
import CancelAcceptForm from "./CancelAcceptForm";
import CustomCheckbox from "./CustomCheckbox";
import { themeTypeToBool, handleFiltersCarListByRegistration, handleFilter, notArrayOrEmpty } from '../../utils/helpers';
import NoData from './NoDataRow';
import FilterParameters from '../Filters/FilterParameters';
import { apiCarGearboxId } from '../../utils/staticData';
import AssignCarsTemplate from "../../templates/AssignCarsTemplate.csv";
import ResetFilters from '../Filters/ResetFilters';
import TableHeader from './TableHeader';
import guid from './../../utils/guid';
import UploadFileOrTemplate from './UploadFileOrTemplate';

const useStyles = theme => ({
    container: {
        margin: theme.spacing(2),
        marginTop: theme.spacing(1),
        padding: theme.spacing(1)
    },
    tableContainer: {
        maxHeight: "55vh"
    },
    cell: {
        padding: theme.spacing(1)
    },
    filters: {
        display: "flex",
        justifyContent: "center",
        paddingBottom: theme.spacing(1)
    },
    csvReader: {
        display: "none"
    },
    title: {
        paddingBottom: 0
    },
    buttonLabel: {
        color: "#FFF"
    }
});

const changeCarSelection = (id, state, availableElements) => {
    return availableElements.map(car => {
        if (car.auto_id === id) {
            car.selected = state;
            return car;
        }
        return car;
    });
};

const changeCollectionCarsState = (state, collectionToChange, availableElements) => {
    return availableElements.map(element => {
        if (collectionToChange.find(item => item.auto_id === element.auto_id))
            element.selected = state;
        return element;
    });
};

//groups
const changeGroupSelection = (id, state, availableElements) => {
    return availableElements.map(group => {
        if (group.grupa_id === id) {
            group.selected = state;
            return group;
        }
        return group;
    });
};

const changeCollectionGroupsState = (state, groups) => {
    return groups.map(group => {
        group.selected = state;
        return group;
    });
};

const AsssignCarsOrGroupsDialog = props => {
    const { classes, theme, open, onClose, onSubmit, title,
        availableCars, carsInGroup, carIdArray, groupFilter, brandFilter, modelFilter, fuelTypeFilter, gearboxFilter,
        availableGroups, gropuIdArray, option, pharse
    } = props;
    const [visibleCars, setVisibleCars] = useState([]);
    const [cars, setCars] = useState([]);
    const [toggleAllStatus, setToggleAllStatus] = useState(false);
    const [toggleAllGroupsStatus, setToggleAllGroupsStatus] = useState(false);
    const [groups, setGroups] = useState([]);
    const [selectedCarsCount, setSelectedCarsCount] = useState(0);
    const [selectedGroupsCount, setSelectedGroupsCount] = useState(0);

    useEffect(() => {
        return () => {
            props.resetToDefaults();
        };
    }, []);

    useEffect(() => {
        setSelectedCarsCount(cars.filter(car => car.selected === true).length);
    }, [cars]);

    useEffect(() => {
        setSelectedGroupsCount(groups.filter(group => group.selected === true).length);
    }, [groups]);

    useEffect(() => {
        let expandedCars = availableCars.filter(availableCar => {
            if (carsInGroup.find(car => car.auto_id === availableCar.auto_id))
                availableCar.selected = true;
            else availableCar.selected = false;
            //if (availableCar.zarchiwizowane === false)
            return availableCar;
        });
        setCars(expandedCars);
    }, [availableCars, carsInGroup]);

    useEffect(() => {
        if (carIdArray) {
            let expandedCars = availableCars.filter(availableCar => {
                if (carIdArray.find(carId => carId === availableCar.auto_id))
                    availableCar.selected = true;
                else availableCar.selected = false;
                //if (availableCar.zarchiwizowane === false)
                return availableCar;
            });
            setCars(expandedCars);
        }
    }, [carIdArray]);

    useEffect(() => {
        let newCars = handleFiltersCarListByRegistration(cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter, pharse);
        newCars = handleFilter(newCars, gearboxFilter, apiCarGearboxId);
        setVisibleCars(newCars);
    }, [cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter, gearboxFilter, pharse]);

    const handleSubmit = () => {
        if (option === 1) {
            let carsToAssign = cars.filter(car => car.selected);
            let carIds = carsToAssign.map(car => car.auto_id);
            if (onSubmit)
                onSubmit(carIds);
        }
        else if (option === 2) {
            let gropusToAssign = groups.filter(group => group.selected);
            let groupIds = gropusToAssign.map(group => group.grupa_id);
            if (onSubmit)
                onSubmit(groupIds);
        }
        else if (option === 3) {
            if (onSubmit)
                onSubmit(null);
        }
    };

    const handleToggle = (id, e) => {
        setCars(changeCarSelection(id, e.target.checked, cars));

    };

    const handleToggleAll = (e) => {
        let newCars = changeCollectionCarsState(e.target.checked, visibleCars, cars);
        setCars(newCars);
        setToggleAllStatus(e.target.checked);
    };

    const handleCsvLoaded = (data) => {
        if (notArrayOrEmpty(data))
            return;
        let registrationNos = data.map(registrationNo => {
            if (registrationNo.Rejestracja.length > 0)
                return registrationNo.Rejestracja;
        });
        let carsToSelect = availableCars.filter(car => {
            if (registrationNos.includes(car.rejestracja))
                car.selected = true;
            return car;
        });
        setCars(carsToSelect);
    };


    useEffect(() => {
        if (gropuIdArray) {
            let expandedGroups = availableGroups.filter(availableGroup => {
                if (gropuIdArray.find(groupId => parseInt(groupId) === availableGroup.grupa_id))
                    availableGroup.selected = true;
                else availableGroup.selected = false;
                return availableGroup;
            });
            setGroups(expandedGroups);
        }
    }, [availableGroups, gropuIdArray]);



    const handleGroupsToggle = (id, e) => {
        setGroups(changeGroupSelection(id, e.target.checked, groups));
    };

    const handleToggleAllGroups = (e) => {
        let newGroups = changeCollectionGroupsState(e.target.checked, groups);
        setGroups(newGroups);
        setToggleAllGroupsStatus(e.target.checked);
    };

    const printGroupList = data => {
        if (!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={3} />;
        return data.map(row => {
            return (
                <TableRow key={row.grupa_id}>
                    <TableCell className={classes.cell}>
                        <CustomCheckbox
                            style={{ color: themeTypeToBool(theme.palette.type) ? "#6B6E77" : "#FAFAFA" }}
                            checked={row.selected}
                            onChange={handleGroupsToggle.bind(this, row.grupa_id)}
                        />
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.grupa_nazwa}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.grupa_opis}
                    </TableCell>
                </TableRow>
            );
        });
    };

    const printList = data => {
        if (!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={3} />;
        return data.map(row => {
            return (
                <TableRow key={row.auto_id}>
                    <TableCell className={classes.cell}>
                        <CustomCheckbox
                            style={{ color: themeTypeToBool(theme.palette.type) ? "#6B6E77" : "#FAFAFA" }}
                            checked={row.selected}
                            onChange={handleToggle.bind(this, row.auto_id)}
                        />
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.rejestracja}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.opis}
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle className={classes.title}>
                {t.assignCars}&nbsp;{title}
            </DialogTitle>
            <DialogContent className={classes.container}>
                <div>
                    {props.children}
                </div>
                {option !== 3 ?
                    <React.Fragment>
                        <div className={classes.filters}>
                            {option === 2
                                ? null
                                :
                                <React.Fragment>
                                    <FilterParameters
                                        registrationNoSearch
                                    />
                                    <ResetFilters />
                                </React.Fragment>}
                        </div>
                        <TableContainer className={classes.tableContainer}>
                            {option !== 2 ?
                                <Table stickyHeader>
                                    <TableHeader
                                        data={[
                                            <CustomCheckbox
                                                key={guid()}
                                                style={{ color: themeTypeToBool(theme.palette.type) ? "#6B6E77" : "#FAFAFA" }}
                                                checked={toggleAllStatus}
                                                onChange={handleToggleAll.bind(this)}
                                            />,
                                            t.registrationNo,
                                            t.description
                                        ]}
                                        align="left"
                                    />
                                    <TableBody>
                                        {printList(visibleCars)}
                                    </TableBody>
                                </Table>
                                :
                                <Table stickyHeader>
                                    <TableHeader
                                        data={[
                                            <CustomCheckbox
                                                key={guid()}
                                                style={{ color: themeTypeToBool(theme.palette.type) ? "#6B6E77" : "#FAFAFA" }}
                                                checked={toggleAllGroupsStatus}
                                                onChange={handleToggleAllGroups.bind(this)}
                                            />,
                                            t.group,
                                            t.description
                                        ]}
                                        align="left"
                                    />
                                    <TableBody>
                                        {printGroupList(groups)}
                                    </TableBody>
                                </Table>
                            }
                        </TableContainer>
                    </React.Fragment>
                    : null}
            </DialogContent>
            <DialogActions>
                {option === null ?
                    <UploadFileOrTemplate
                        template={AssignCarsTemplate}
                        onFileLoaded={handleCsvLoaded}
                        tooltipText={t.importCsvDescriptionCar}
                    />
                    : null
                }
                <CancelAcceptForm
                    onCancel={onClose}
                    onSubmit={handleSubmit}
                    disableSubmit={(option === 1 && selectedCarsCount === 0) || (option === 2 && selectedGroupsCount === 0)}
                />
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => ({
    availableCars: state.carsReducer.cars,
    groupFilter: state.filterReducer.group,
    brandFilter: state.filterReducer.brand,
    modelFilter: state.filterReducer.model,
    fuelTypeFilter: state.filterReducer.fuelType,
    gearboxFilter: state.filterReducer.gearbox,
    pharse: state.filterReducer.searchField,
    //groups
    availableGroups: state.groupReducer.groups,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

AsssignCarsOrGroupsDialog.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    open: PropTypes.bool,
    title: PropTypes.string,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    children: PropTypes.node,
    carsInGroup: PropTypes.array,
    carIdArray: PropTypes.array,
    option: PropTypes.number,
    pharse: PropTypes.string,
    //redux
    availableCars: PropTypes.array,
    changeAvailableCarSelection: PropTypes.func,
    groupFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    brandFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    modelFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fuelTypeFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    gearboxFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    resetToDefaults: PropTypes.func,
    notifyError: PropTypes.func,
    //groups
    availableGroups: PropTypes.array,
    gropuIdArray: PropTypes.array,
};

AsssignCarsOrGroupsDialog.defaultProps = {
    carsInGroup: [],
    availableGroups: []
};

export default compose(
    withStyles(useStyles, { withTheme: true }),
    withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(AsssignCarsOrGroupsDialog);
